import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/auth';
import { AutoCompleteBox, FormButton, SelectInputBox } from "../commoncomponents/InputBox";
import { Table } from '../commoncomponents/Table';

//loder
import BlurLoader from "../Loder/BlurLoader";

//react toast 
import { toast } from 'react-toastify';

//common Data
import { API_SERVER, initializeFilterData } from '../../Utils';

//services
import { getCommonData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service';
import { Token } from '../Common/Common';

function UpdateDepartment_Designation() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();


    //Get PathName
    let url = window.location.pathname.split("/")
    const pathName = url[url.length - 1]


    //token Data
    const TokenData = Token()
    //initial state
    const initialState = {
        UpdateType: '',
        Company: '',
        Employee: '',
        Department: '',
        Designation: '',
        PageType: "UpdateDepartment_Designation"
    }

    const [recipe, setRecipe] = useState(initialState)
    const [selectedEmployee, setSelectedEmployee] = useState([])
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false)
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)

    const [checkboxId, setCheckboxId] = useState(false);

    const [isUpdate, setIsUpdate] = useState(false)
    const [companyAllData, setCompanyAllData] = useState([])
    const [employeeAllData, setEmployeeAllData] = useState([])
    const [departmentAllData, setDepartmentAllData] = useState([])
    const [designationAllData, setDesignationAllData] = useState([])

    const GetCompanyData = () => {
        let temp = {
            Type: "GetCompany",
            Prefix: '',
            ContextKey: "",
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setCompanyAllData(data)
                }
            }
        });
    }
    //Get Employee Autocomplete Data
    const getEmployeeData = (value) => {
        let temp = {
            Type: "GetCompanyWiseEmployee",
            Prefix: '',
            ContextKey: value ? value : '',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeAllData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setEmployeeAllData(data)
                }
            }
        });
    }

    //Get Department Autocomplete Data
    const getDepartmentData = (value) => {
        let temp = {
            Type: "GetCompanyWiseDepartment",
            Prefix: '',
            ContextKey: value ? value : '',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setDepartmentAllData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setDepartmentAllData(data)
                }
            }
        });
    }

    //Get Designation Autocomplete Data
    const getDesignationData = (value) => {
        let temp = {
            Type: "GetCompanyWiseDesignation",
            Prefix: '',
            ContextKey: value ? value : '',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setDesignationAllData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setDesignationAllData(data)
                }
            }
        });
    }

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //Submit Handler
    const handleSubmit = (CurrentPage) => {

        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        setLoading(true)
        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s"
        }
        post(`${API_SERVER}api/Employee/SearchEmpDepartmentDesignation`, { ...TokenData, ...temp, ...sortConfig, ...filterData, ...recipe, PageType: "UpdateDepartment_Designation" }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    setResult({ ...res })
                    setSelectedEmployee([])
                }
            }
        });
    }

    const handleChange1 = (event, value) => {
        handleSubmit(value);
    };

    //Handle Check Box
    const handleCheckData = (Id, e, item) => {
        setCheckboxId(Id);
        const department_designation =
            recipe?.UpdateType?.toLowerCase() === "department"
                ? item?.NewDepartment
                : item?.NewDesignation || "";

        if (e === true) {
            setSelectedEmployee((prevValue) => {
                const existingIndex = prevValue.findIndex(
                    (ele) => ele.split("|")[0] === Id
                );
                const newEntry = `${Id}|${department_designation}|${item?.EffectiveDate}`;

                if (existingIndex !== -1) {
                    const updated = [...prevValue];
                    updated[existingIndex] = newEntry;
                    return updated;
                } else {
                    return [...prevValue, newEntry];
                }
            });
        } else if (e === false) {
            const updatedIds = selectedEmployee.filter(
                (ele) => ele.split("|")[0] !== Id
            );
            setSelectedEmployee(updatedIds);
        }
    };

    const handleUpadateDepartment_Designation = () => {
        if (selectedEmployee.length <= 0) {
            toast.error('Please select at least one employee.!')
        } else {
            post(`${API_SERVER}api/Employee/UpdateEmpDepartmentDesignation`, { ...TokenData, UpdateType: recipe.UpdateType, EmpDepartmentDesignationDetails: (selectedEmployee.length > 0 ? `${selectedEmployee.join(",")}` : '') }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message);
                        setLoading(false);
                    } else if (res.status === "EXPIRED") {
                        toast.error(res.message);
                        sessionExpired();
                    } else if (res.status === "UNAUTHORIZED") {
                        toast.error(res.message);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        setSelectedEmployee([]);
                        handleSubmit();
                        document.getElementById(`row${checkboxId}checkBox`).checked = false;
                        toast.success(res.message);
                    }
                }
            });
        }
    }


    //Reset Handler
    const handleClear = () => {
        setRecipe(initialState)
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        setSelectedEmployee([])
        handleSubmit();
        if (checkboxId) document.getElementById(`row${checkboxId}checkBox`).checked = false;
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    let EmployeeData = []
    for (let i = 0; i < employeeAllData.length; i++) {
        let mydata = employeeAllData[i]?.values
        EmployeeData.push(mydata)
    };

    let CompanyData = []
    for (let i = 0; i < companyAllData.length; i++) {
        let mydata = companyAllData[i]?.values
        CompanyData.push(mydata)
    };

    let DepartmentData = []
    for (let i = 0; i < departmentAllData.length; i++) {
        let mydata = departmentAllData[i]?.values
        DepartmentData.push(mydata)
    };

    let DesignationData = []
    for (let i = 0; i < designationAllData.length; i++) {
        let mydata = designationAllData[i]?.values
        DesignationData.push(mydata)
    };


    useEffect(() => {
        inputrefs.current['txtUpdateType'].focus()
        document.title = 'Viva HRMS: Update Department/Designation'
        handleSubmit()
        getEmployeeData()
        getDepartmentData()
        getDesignationData()
        GetCompanyData();
    }, [sortConfig, isUpdate])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> Update Department/Designation</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <SelectInputBox
                            label='Update Type'
                            inputrefs={inputrefs}
                            required
                            id="txtUpdateType"
                            value={recipe.UpdateType}
                            error={errors.UpdateType}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtCompany'].focus() };
                            }}
                            onChange={(e) => HandleChange('UpdateType', e.target.value)}
                            children={<>
                                <option value="">--Select Document Update Type--</option>
                                <option value="department">Department</option>
                                <option value="designation">Designation</option>
                            </>}
                        />
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtEmployee'].focus() };
                            }}
                            required
                            label='Company'
                            placeholder="Company"
                            maxLength='50'
                            options={CompanyData}
                            id='txtCompany'
                            error={errors.Company}
                            inputValue={recipe.Company ? recipe.Company : ''}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Company', newInputValue)
                            }}
                        />
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDepartment'].focus() };
                            }}
                            label='Employee'
                            placeholder="Employee"
                            maxLength='50'
                            options={EmployeeData}
                            id='txtEmployee'
                            error={errors.Employee}
                            inputValue={recipe.Employee ? recipe.Employee : ''}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Employee', newInputValue)
                            }}
                        />
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDesignation'].focus() };
                            }}
                            label='Department'
                            placeholder="Department"
                            maxLength='50'
                            options={DepartmentData}
                            id='txtDepartment'
                            error={errors.Department}
                            inputValue={recipe.Department ? recipe.Department : ''}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Department', newInputValue)
                            }}
                        />
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { handleSubmit() };
                            }}
                            label='Designation'
                            placeholder="Designation"
                            maxLength='50'
                            options={DesignationData}
                            id='txtDesignation'
                            error={errors.Designation}
                            inputValue={recipe.Designation ? recipe.Designation : ''}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Designation', newInputValue)
                            }}
                        />
                        <FormButton
                            SaveText='Search'
                            Next={true}
                            Export={false}
                            saveButtonIcon='fa-search'
                            nextButtonText='Update'
                            nextButtonIcon='fa-check'
                            nextButtonColor='btn-success'
                            handleNext={handleUpadateDepartment_Designation}
                            handleSubmit={handleSubmit}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

       
            <Table
                Filter={false}
                pathName={pathName}
                Token={TokenData}
                PageName='UpdateDepartment_Designation'
                handleCheckData={handleCheckData}
                handleFilter={() => {
                    handleSubmit();
                    setFilterData({
                        ...filterData,
                    });
                }}
                tableData={result}
                filterData={filterData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

            {/* Loder start*/}
            {loading && < BlurLoader />}
            {/* Loder End*/}

        </>
    )
}

export default UpdateDepartment_Designation;